import * as moduleTypes from './types'

export const saveExceptionNoteRequest = (payload) => ({
  type: moduleTypes.SAVE_EXCEPTION_NOTE_REQUEST,
  payload,
})

export const saveExceptionNoteSuccess = (payload) => ({
  type: moduleTypes.SAVE_EXCEPTION_NOTE_SUCCESS,
  payload,
})

export const saveExceptionNoteError = (error) => ({
  type: moduleTypes.SAVE_EXCEPTION_NOTE_ERROR,
  error,
})

// Action for triggering the effect (handled by redux-observable)
export const saveExceptionNote = (payload, options) => ({
  type: moduleTypes.SAVE_EXCEPTION_NOTE,
  payload,
  options,
})

// GET notes actions
export const getExceptionNotesRequest = (payload) => ({
  type: moduleTypes.GET_EXCEPTION_NOTES_REQUEST,
  payload,
})

export const getExceptionNotesSuccess = (payload, meta) => ({
  type: moduleTypes.GET_EXCEPTION_NOTES_SUCCESS,
  payload,
  meta,
})

export const getExceptionNotesError = (error) => ({
  type: moduleTypes.GET_EXCEPTION_NOTES_ERROR,
  error,
})

export const getExceptionNotes = (payload, options = {}) => ({
  type: moduleTypes.GET_EXCEPTION_NOTES,
  payload,
  options: {
    resourceId: options.resourceId,
    queryParams: options.queryParams,
  },
})

// UPDATE note actions
export const updateExceptionNoteRequest = (payload) => ({
  type: moduleTypes.UPDATE_EXCEPTION_NOTE_REQUEST,
  payload,
})

export const updateExceptionNoteSuccess = (payload) => ({
  type: moduleTypes.UPDATE_EXCEPTION_NOTE_SUCCESS,
  payload,
})

export const updateExceptionNoteError = (error) => ({
  type: moduleTypes.UPDATE_EXCEPTION_NOTE_ERROR,
  error,
})

export const updateExceptionNote = (payload, options) => ({
  type: moduleTypes.UPDATE_EXCEPTION_NOTE,
  payload,
  options,
})

// DELETE note actions
export const deleteExceptionNoteRequest = (payload) => ({
  type: moduleTypes.DELETE_EXCEPTION_NOTE_REQUEST,
  payload,
})

export const deleteExceptionNoteSuccess = (payload) => ({
  type: moduleTypes.DELETE_EXCEPTION_NOTE_SUCCESS,
  payload,
})

export const deleteExceptionNoteError = (error) => ({
  type: moduleTypes.DELETE_EXCEPTION_NOTE_ERROR,
  error,
})

export const deleteExceptionNote = (payload, options) => ({
  type: moduleTypes.DELETE_EXCEPTION_NOTE,
  payload,
  options,
})

export const getExceptionIssueRequest = () => ({
  type: moduleTypes.GET_EXCEPTION_ISSUE_REQUEST,
})

export const getExceptionIssueSuccess = (payload) => ({
  type: moduleTypes.GET_EXCEPTION_ISSUE_SUCCESS,
  payload,
})

export const getExceptionIssueError = (error) => ({
  type: moduleTypes.GET_EXCEPTION_ISSUE_ERROR,
  error,
})

export const getExceptionIssue = (payload, options = {}) => ({
  type: moduleTypes.GET_EXCEPTION_ISSUE,
  payload,
  options: {
    resourceId: options.resourceId,
    queryParams: options.queryParams,
  },
})

export const getExceptionHistoryRequest = () => ({
  type: moduleTypes.GET_EXCEPTION_HISTORY_REQUEST,
})

export const getExceptionHistorySuccess = (payload) => ({
  type: moduleTypes.GET_EXCEPTION_HISTORY_SUCCESS,
  payload,
})

export const getExceptionHistoryError = (error) => ({
  type: moduleTypes.GET_EXCEPTION_HISTORY_ERROR,
  error,
})

export const getExceptionHistory = (payload, options = {}) => ({
  type: moduleTypes.GET_EXCEPTION_HISTORY,
  payload,
  options: {
    resourceId: options.resourceId,
    queryParams: options.queryParams,
  },
})

export const acknowledgeExceptions = (payload, options) => ({
  type: moduleTypes.ACKNOWLEDGE_EXCEPTIONS,
  payload,
  options,
})

export const reset = () => ({
  type: moduleTypes.RESET,
})

export const requestAcknowledgeExceptions = (payload, options) => ({
  type: moduleTypes.ACKNOWLEDGE_EXCEPTIONS,
  payload,
  options,
})

export const requestAcknowledgeExceptionsError = (payload, options) => ({
  type: moduleTypes.ACKNOWLEDGE_EXCEPTIONS_ERROR,
  payload,
  options,
})

export const requestAcknowledgeExceptionsFulfilled = (payload, options) => ({
  type: moduleTypes.ACKNOWLEDGE_EXCEPTIONS_FULFILLED,
  payload,
  options,
})
